/**
 * Announcement Banner — session dismiss via sessionStorage (key per component instance id).
 */
const anchorDomUtils = require('./utils/anchorDomUtils');

(function initLvzAnnouncementBanner() {
	const STORAGE_PREFIX = 'lvz-announcement-dismissed-';

	/**
	 * Rewrites the href of every <a> inside `.lvz-announcement-banner__text-wrap`
	 * to the anchor reference defined in its `data-lvz-announcement-anchor` attribute.
	 *
	 * @param {Element} root - The section[data-lvz-announcement] element.
	 */
	function replaceLinksReference(root) {
		const textWrap = root.querySelector('.lvz-announcement-banner__text-wrap');
		if (!textWrap) return;

		// Use the same anchor-id normalization rules as the Anchor Sub Menu so different
		// editorial components resolve in-page links consistently.
		const anchorId = anchorDomUtils.sanitizeAnchorId(textWrap.getAttribute('data-lvz-announcement-anchor'));
		if (!anchorId) {
			// If no Anchor ID is specified, set link target
			const target = textWrap.getAttribute('data-lvz-announcement-target') || '_self';
			textWrap.querySelectorAll('a').forEach(function (link) {
				link.setAttribute('target', target);
			});
		} else {
			// Remove links
			textWrap.querySelectorAll('a').forEach(function (link) {
				link.setAttribute('href', 'javascript:void(0)');
				link.removeAttribute('target');
				link.removeAttribute('rel');
			});
			// Scroll to target
			textWrap.addEventListener('click', function (_) {
				const target = anchorDomUtils.getAnchorTarget(anchorId, document);
				if (target) {
					target.scrollIntoView({ behavior: 'smooth' });
				}
			});
		}
	}

	/**
	 * @param {Element} root
	 */
	function hideBanner(root) {
		root.setAttribute('hidden', 'hidden');
		root.setAttribute('aria-hidden', 'true');
	}

	/**
	 * @param {Element} root
	 */
	function showBanner(root) {
		root.removeAttribute('hidden');
		root.setAttribute('aria-hidden', 'false');
	}

	/**
	 * @param {Element} root
	 */
	function initOne(root) {
		const edit = root.getAttribute('data-lvz-announcement-edit') === 'true';
		const id = root.getAttribute('data-lvz-announcement-id') || '';
		const key = id ? STORAGE_PREFIX + id : '';

		if (!edit && key && window.sessionStorage.getItem(key) === '1') {
			return;
		}

		replaceLinksReference(root);

		showBanner(root);

		const closeBtn = root.querySelector('[data-lvz-announcement-close]');
		if (!closeBtn) {
			return;
		}

		closeBtn.addEventListener('click', () => {
			if (!edit && key) {
				try {
					window.sessionStorage.setItem(key, '1');
				} catch (e) {
					/* ignore quota / private mode */
				}
			}
			hideBanner(root);
		});
	}

	function boot() {
		document.querySelectorAll('[data-lvz-announcement]').forEach(initOne);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
